/* LAVY cart drawer: delivery estimate, reservation timer, Complete the look */
(function () {
  if (window.nrCartDrawerBoot) return;
  window.nrCartDrawerBoot = true;
  var KEY = 'nrCartTimerStart';
  var recsCache = {};

  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }
  function fmt(d) {
    try {
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    } catch (e) {
      return d.toDateString().slice(4, 10);
    }
  }
  function eta(root) {
    root.querySelectorAll('.nr-cd__eta:not([data-ready])').forEach(function (el) {
      var mn = parseInt(el.dataset.min, 10) || 7;
      var mx = parseInt(el.dataset.max, 10) || mn;
      if (mx < mn) mx = mn;
      var now = new Date();
      var a = fmt(addBusinessDays(now, mn));
      var b = fmt(addBusinessDays(now, mx));
      el.textContent = (el.dataset.label ? el.dataset.label + ' ' : '') + a + (b !== a ? ' – ' + b : '');
      el.dataset.ready = '1';
    });
  }

  function getStart() {
    try { return parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) { return 0; }
  }
  function setStart(v) {
    try { if (v) { localStorage.setItem(KEY, String(v)); } else { localStorage.removeItem(KEY); } } catch (e) {}
  }
  function tick() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    if (cd.classList.contains('is-empty')) { setStart(0); return; }
    var t = cd.querySelector('.nr-cd__timer');
    if (!t) return;
    var mins = parseInt(t.dataset.minutes, 10) || 5;
    var start = getStart();
    if (!start) { start = Date.now(); setStart(start); }
    var left = start + mins * 60000 - Date.now();
    if (left > 0) {
      var el = t.querySelector('.nr-cd__time');
      var m = Math.floor(left / 60000);
      var s = Math.floor((left % 60000) / 1000);
      var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (el && el.textContent !== txt) el.textContent = txt;
    } else if (!t.dataset.done) {
      t.dataset.done = '1';
      t.textContent = '';
      var p = document.createElement('p');
      p.className = 'nr-cd__timer-main';
      p.textContent = t.dataset.expired || '';
      t.appendChild(p);
    }
  }

  function fillRecs(box, html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var exclude = (box.dataset.exclude || '').split(',');
    var list = box.querySelector('.nr-upsell__list');
    var limit = parseInt(box.dataset.limit, 10) || 2;
    var n = 0;
    tmp.querySelectorAll('.nr-up').forEach(function (card) {
      if (n >= limit) return;
      if (exclude.indexOf(card.dataset.productId) > -1) return;
      list.appendChild(card);
      n++;
    });
    if (n > 0) box.hidden = false;
  }
  function recs(root) {
    root.querySelectorAll('[data-nr-recs]:not([data-ready])').forEach(function (box) {
      box.dataset.ready = '1';
      if (!box.dataset.productId) return;
      var url = box.dataset.url + '?section_id=nr-cart-recommendations&product_id=' + box.dataset.productId + '&limit=10&intent=' + box.dataset.intent;
      if (recsCache[url]) { fillRecs(box, recsCache[url]); return; }
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) { recsCache[url] = html; fillRecs(box, html); })
        .catch(function () {});
    });
  }

  function init() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    eta(cd);
    recs(cd);
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('select.nr-up__select');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var now = sel.closest('.nr-up').querySelector('.nr-up__now');
    if (now && opt && opt.dataset.price) now.textContent = opt.dataset.price;
  });

  function showError(card, msg) {
    var err = card.querySelector('.nr-up__err');
    if (!err) {
      err = document.createElement('p');
      err.className = 'nr-up__err';
      err.setAttribute('role', 'alert');
      card.appendChild(err);
    }
    err.textContent = msg || 'Something went wrong. Please try again.';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.nr-up__add');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.nr-up');
    var sel = card.querySelector('select.nr-up__select');
    var id = sel ? sel.value : btn.dataset.variantId;
    if (!id) return;
    btn.disabled = true;
    btn.classList.add('loading');
    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(id, 10), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var cd = document.querySelector('cart-drawer');
        if (res.status || !res.sections || !cd || typeof cd.renderContents !== 'function') {
          btn.disabled = false;
          btn.classList.remove('loading');
          showError(card, res.description || res.message);
          return;
        }
        cd.classList.remove('is-empty');
        cd.renderContents(Object.assign({ id: parseInt(id, 10) }, res));
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'nr-cart-upsell', productVariantId: id, cartData: res });
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('loading');
        showError(card);
      });
  });

  function boot() {
    init();
    var cd = document.querySelector('cart-drawer');
    if (cd) {
      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(init, 60);
      }).observe(cd, { childList: true, subtree: true });
    }
    tick();
    setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
